import { render, staticRenderFns } from "./OperatParameter.vue?vue&type=template&id=51f04784&scoped=true"
import script from "./OperatParameter.vue?vue&type=script&lang=ts"
export * from "./OperatParameter.vue?vue&type=script&lang=ts"
import style0 from "./OperatParameter.vue?vue&type=style&index=0&id=51f04784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f04784",
  null
  
)

export default component.exports